import * as Yup from "yup";
import {yupRequiredPositiveOrZeroNumber, yupRequiredString} from "../yup/Validators";

export const CreateVATRateSchema = Yup.object().shape({
  name: yupRequiredString,
  rate: yupRequiredPositiveOrZeroNumber,
})
